import React from 'react';
import { Table } from 'semantic-ui-react';
import { GlobalFilter } from 'components/atoms/tables/smarttables/Filters';

const GlobalSearch = ({ tableProps, controlledSearch, updateSearch, globalSearchPlaceholder, freeze }) => {
    const { allColumns, preGlobalFilteredRows, state } = tableProps;
    return (<Table.Header>
        <Table.Row>
            <Table.HeaderCell
                colSpan={allColumns.length}
                style={{
                    textAlign: 'left',
                    ...(freeze ? {
                        position: 'sticky',
                        top: '0px',
                        zIndex: '10'
                    } : {})

                }}
            >
                <GlobalFilter
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    globalFilter={controlledSearch || state.globalFilter}
                    setGlobalFilter={updateSearch}
                    placeholder={globalSearchPlaceholder}
                />
            </Table.HeaderCell>
        </Table.Row>
    </Table.Header>
    );
};
export default GlobalSearch;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/GlobalSearch.js